const SOCIAL_ICONS = {
  twitter: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
  ),
  instagram: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
    </svg>
  ),
  linkedin: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.05-1.86-3.05-1.86 0-2.15 1.45-2.15 2.95v5.67H9.34V9h3.41v1.56h.05c.48-.9 1.64-1.86 3.38-1.86 3.61 0 4.27 2.38 4.27 5.47zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.99 0 1.78-.77 1.78-1.72V1.72C24 .77 23.21 0 22.22 0z" /></svg>
  ),
  muckrack: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 4h16v16H4z" />
      <path d="M8 8l3 8 1-5 1 5 3-8" />
    </svg>
  ),
  cbc: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </svg>
  ),
};

const LABELS = {
  twitter: "Twitter / X",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  muckrack: "Muck Rack",
  cbc: "CBC Author Page",
};

export default function Contact({ profile }) {
  const socials = profile?.socials || {};
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#0A0A0A] text-[#EAEAEA] py-24 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-[#C4A27A]" />
          <span className="font-mono-overline text-[#C4A27A]">07 — Contact</span>
        </div>

        <h2 data-testid="contact-heading" className="display-xl text-[#EAEAEA] text-5xl sm:text-7xl md:text-[8rem] leading-[0.9]">
          Let&rsquo;s <em className="text-[#C4A27A]">talk</em>.
        </h2>

        <p className="mt-8 text-[#EAEAEA]/75 max-w-2xl text-base md:text-lg leading-relaxed">
          Pitches, collaborations, festival enquiries — I read everything. Best reached by email or social.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <div className="font-mono-overline text-[#C4A27A] mb-3">Email</div>
            <a
              data-testid="contact-email"
              href={`mailto:${profile?.email}`}
              className="font-serif-display text-3xl md:text-5xl text-[#EAEAEA] hover:text-[#C4A27A] transition-colors break-all border-b border-white/15 hover:border-[#C4A27A] inline-block pb-1"
            >
              {profile?.email}
            </a>
          </div>

          <div>
            <div className="font-mono-overline text-[#C4A27A] mb-5">Elsewhere</div>
            <ul className="space-y-4">
              {Object.entries(socials).map(([key, url]) => (
                <li key={key}>
                  <a
                    data-testid={`social-${key}`}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center gap-4 text-[#EAEAEA]/85 hover:text-[#C4A27A] transition-colors"
                  >
                    <span className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center group-hover:border-[#C4A27A] group-hover:bg-[#C4A27A] group-hover:text-[#0A0A0A] transition-all">
                      {SOCIAL_ICONS[key] || (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10 14l11-11M21 3v7M21 3h-7" /><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" /></svg>
                      )}
                    </span>
                    <span className="font-serif-display text-xl md:text-2xl">{LABELS[key] || key}</span>
                    <svg className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M9 7h8v8" /></svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-overline text-[#EAEAEA]/50">
            © {new Date().getFullYear()} {profile?.name} · All rights reserved
          </div>
          <div className="font-mono-overline text-[#EAEAEA]/40">
            {profile?.location}
          </div>
        </div>
      </div>
    </section>
  );
}
